import { render, staticRenderFns } from "./NoticeExhibition.vue?vue&type=template&id=681a684e&scoped=true"
import script from "./NoticeExhibition.vue?vue&type=script&lang=js"
export * from "./NoticeExhibition.vue?vue&type=script&lang=js"
import style0 from "./NoticeExhibition.vue?vue&type=style&index=0&id=681a684e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a684e",
  null
  
)

export default component.exports